import { useEffect, useRef } from 'react'

export function useInitiallyOpenSelect(shouldOpen = true) {
  const selectStatesRef = useRef(null)

  useEffect(() => {
    if (shouldOpen) {
      selectStatesRef.current?.handleOpen?.()
    }
  }, [])

  return selectStatesRef
}
